import dayjs from 'dayjs'
import * as Yup from 'yup'

Yup.addMethod(Yup.string, 'validateDate', function (errorMessage) {
  return this.test(`test-date`, errorMessage, function (value) {
    const { path, createError } = this

    return dayjs(value).isValid() || createError({ path, message: errorMessage })
  })
})

export const getEditFieldSchema = (
  label: string,
  type: 'input' | 'select' | 'date' | 'email',
  requiredError?: string,
) => {
  const requiredMessage = requiredError || `${label} is required`
  let value = Yup.string().required(requiredMessage)

  if (type === 'date') {
    // @ts-ignore
    value = Yup.string().required(requiredMessage).validateDate('Invalid date')
  }

  if (type === 'email') {
    // @ts-ignore
    value = Yup.string().required(requiredMessage).email('Invalid email')
  }

  return Yup.object().shape({
    value,
  })
}
